import styled from 'styled-components';
import {useRelativeTime, useUsername} from "../store";
import {themecolors} from "../utils/themecolors";
import NavLink from "./nav_link";

const Subject = styled.div``;
const Details = styled.div``;

export const Author = ({className, username}) => {
    const isCommunityMail = username.startsWith("c:");
    const displayName = isCommunityMail ? `/c/${username.split("c:")[1]}` : `${username}`;
    return (
        <span className={className}>
            <NavLink href={`${displayName}`} react_route style={{fontWeight: username === "Scored" ? 500 : 400, color: username === 'Scored' ? themecolors.red : 'inherit'}}>{displayName}</NavLink>
        </span>
    )
};

/**
 * @param className {string}
 * @param showTitle {boolean}
 * @param message {{is_community_mail: boolean, author: string, subject: string, created: number, type: number, community: string, is_muted: boolean, content: string, is_deleted: boolean, post_id: number, is_archived: boolean, conversation_id: number, is_unread: boolean, recipient: string, outbound_link: string, id: number}}
 * @returns {JSX.Element}
 */
const Message = styled(({className, showSubject, message}) => {
    const ago = useRelativeTime(message?.created);
    const username = useUsername();
    const sent = message.author === username;
    return (

        <div className={className}>
            {showSubject && (
                <Subject>
                    {message.subject}
                </Subject>
            )}
            <Details>
                {sent ?
                    <>To <Author username={message.recipient} /> - {ago} ago</>
                    :
                    <><Author username={message.author} /> - {ago} ago</>
                }
            </Details>
            {message.content && <div dangerouslySetInnerHTML={{__html: message.content}}/>}
            {message.is_deleted && <div>Deleted</div>}
        </div>

    );
})`
  background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_1 : theme.white_0};
  padding: 16px;
  font-size: 14px;

  ${Subject} {
    font-size: 15px;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_high_impact_text : themecolors.light_high_impact_text};
    font-weight: 600;
  }

  ${Details} {
    font-size: 13px;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_low_impact_text : themecolors.light_low_impact_text};
    margin-bottom: 8px;
  }
`;

export default Message;
